import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState, mapActions } from '@/store/helpers';
import { usePageStore } from '@/store';
import { normal } from '../defaultSpacing';

import spaceMixin from '@/modules/space-mixin';
import colorMixin from '@/modules/color-mixin';

import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData, getBlogs } from './asyncData';
import * as TYPES from './_store/types';
export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-blog'
    },
    mixins: [spaceMixin('colorBlock'), colorMixin()],
    asyncData: mapAsyncData(asyncData),
    data: function() {
        return {
            title: '',
            showMore: true,
            moreText: '',
            moreLink: '',
            moreTarget: true,
            moreType: '',
            morePage: '',
            titleSize: '',
            blogNum: 3, // exhibit blog quantity 
            categoryId: 0,
            ...normal,
            showCardNum: 3, // new theme: layout1
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png',
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "itemLinkTarget": store => store.page?.blogDetailOpenStyle || '_self'
        }),
        ...mapState({
            "listing": "listing",
            "showSliderBtns": "showSliderBtns"
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        moreLinkByCategory() {
            let hasUrlParam = this.moreLink.indexOf('?') > -1;
            return `${this.moreLink}${hasUrlParam ? '&' : '?'}categoryId=${this.categoryId
                }`;
        },
        suitableImg() {
            return this.isMobileSize
                ? this.bgImgOpt.mobileSrc
                : this.bgImgOpt.src;
        }
    },
    methods: {
        ...mapActions({
            "setListing": TYPES.SET_LISTING,
            "setSliderBtns": TYPES.SET_SLIDER_BTNS
        }),
        ...mapAsyncData({
            getBlogs
        }),
        blogAlt(blog) {
            return blog.imageAltText || this.$t('md-blog.featureImageOf', { title: blog.title });
        },
        async updateBlog() {
            let listing = await this.getBlogs({
                pageSize: this.blogNum,
                categoryIds: this.categoryId
            });
            this.setListing(listing);
            const isShow = !this.isMobileSize && listing.length > this.showCardNum;
            this.setSliderBtns(isShow);
        }
    }
};
